import { Result } from "./utils/result.js"



/**
 * pwa_is_there_sync checks if there is sync api support in the browser. If there is it returns the service worker registration
 *
 * # Notes
 * - No all browser support the sync manager in workers context
 *
 * # Resources
 * [Mozilla](https://developer.mozilla.org/en-US/docs/Web/API/Background_Synchronization_API#browser_compatibility)
 * @return {ServiceWorkerRegistration}
 **/
export async function pwa_is_there_sync() {
  const reg = await navigator.serviceWorker?.ready;
  if (reg == undefined) return Result.new_error(new Error("no service worker found"))

  if ("sync" in reg) {
    return Result.new_value(reg)
  }
  return Result.new_error(new Error("sync is not supported in this browser"))
}
